import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  standardBox: {
    fontSize: 60,
    color: theme.palette.redDark,
  },
}));
